export default "__VITE_ASSET__$iBClYDm__"